/**
 * S46b — report header: title, subtitle, accent rule, period/scope + generated/sources.
 */
import { el } from '../../core/dom.js';
import { resolvedOf } from './shape.js';

/**
 * @param {object} block
 * @returns {HTMLElement}
 */
export function renderReportHeader(block) {
  const data = resolvedOf(block);
  const periodScope = [data.period, data.scope].filter((part) => part != null && String(part).trim()).map(String);
  const sources = Array.isArray(data.sources)
    ? data.sources.map((item) => String(item)).filter(Boolean)
    : [];
  const generatedBits = [];
  if (data.generated) generatedBits.push(`Generated ${data.generated}`);
  if (sources.length) generatedBits.push(`Sources ${sources.join(', ')}`);
  return el('header', {
    class: 'chat-block chat-block-report-header',
    'data-block-type': 'report-header',
    'data-block-id': (block && block.id) || '',
    'aria-label': data.title ? String(data.title) : 'Report',
  },
  data.title ? el('h2', { class: 'chat-report-title' }, String(data.title)) : null,
  data.subtitle ? el('p', { class: 'chat-report-subtitle' }, String(data.subtitle)) : null,
  el('div', { class: 'chat-report-rule', 'aria-hidden': 'true' }),
  periodScope.length
    ? el('p', { class: 'chat-report-meta' }, periodScope.join(' · '))
    : null,
  generatedBits.length
    ? el('p', { class: 'chat-report-meta' }, generatedBits.join(' · '))
    : null);
}
